import { render, staticRenderFns } from "./BackendComponent.vue?vue&type=template&id=25efc96c"
import script from "./BackendComponent.vue?vue&type=script&lang=js"
export * from "./BackendComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports